// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"933":"auth","945":"dashboard"}[chunkId] || chunkId) + "." + {"412":"408223a9","933":"ff5eb9d0","945":"bdeac5a0"}[chunkId] + ".chunk.css";
};